import { Component, Inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: 'app-error-dialog',
  template: `
   <div class="text-center pt-4">
    <i class="bi bi-x-circle text-danger fs-1"></i>
   </div>

   <div class="mx-5 pt-2">
     <h1 class="text-center">Error</h1>
   </div>

   <div class="mx-5 text-center">
     <p>{{ data?.errorMessage || 'An error occurred while performing the operation.' }}</p>
   </div>

   <div class="pt-2 pb-4 d-flex justify-content-center">
     <button type="button" class="btn btn-dark" (click)="closeDialog()">OK</button>
   </div>
  `,
})
export class ErrorDialogComponent {

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  closeDialog() {
    this.dialog.closeAll();
  }
}